import React from 'react'
export const PromoCodeIcon = () => (
  <ion-icon
    id="down_card_icon"
    style={{ fontSize: '1.5rem', left: '.5rem' }}
    name="key-outline"
  ></ion-icon>
)
